import { formatTime } from "./constants"

export default function TimelineRuler({
  totalDuration,
  pxPerSec,
}: {
  totalDuration: number
  pxPerSec: number
}) {
  const totalWidth = totalDuration * pxPerSec
  // Place a marker every 2 seconds
  const interval = 2
  const markers: number[] = []
  for (let t = 0; t <= totalDuration; t += interval) {
    markers.push(t)
  }

  return (
    <div className="relative h-5 border-b border-stone/20" style={{ width: totalWidth }}>
      {markers.map((t) => (
        <div
          key={t}
          className="absolute top-0 flex h-full flex-col items-start"
          style={{ left: t * pxPerSec }}
        >
          <div className="h-2 w-px bg-stone/40" />
          <span className="ml-0.5 text-[9px] tabular-nums text-warm-grey/60">
            {formatTime(t)}
          </span>
        </div>
      ))}
    </div>
  )
}
